module.exports = __webpack_public_path__ + "static/media/evidence-based.4a99ca94.svg";